import { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { windowSize as windowSizeState } from '../store/uiStore'

const getWidth = () =>
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth

const getHeight = () =>
  window.innerHeight ||
  document.documentElement.clientHeight ||
  document.body.clientHeight

const useWindowResize = () => {
  const [windowSize, setWindowSize] = useRecoilState(windowSizeState)
  let vw = getWidth() * 0.01
  let vh = getHeight() * 0.01
  document.documentElement.style.setProperty('--vw', `${vw}px`)
  document.documentElement.style.setProperty('--vh', `${vh}px`)
  document.documentElement.style.setProperty('--window-width', `${getWidth()}px`)
  document.documentElement.style.setProperty('--window-height', `${getHeight()}px`)

  useEffect(() => {
    let timeoutId = null
    const resizeListener = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        setWindowSize({
          width: getWidth(),
          height: getHeight(),
        })
        let vw = getWidth() * 0.01
        let vh = getHeight() * 0.01
        document.documentElement.style.setProperty('--vw', `${vw}px`)
        document.documentElement.style.setProperty('--vh', `${vh}px`)
        document.documentElement.style.setProperty('--window-width', `${getWidth()}px`)
        document.documentElement.style.setProperty('--window-height', `${getHeight()}px`)
      }, 100)
    }
    window.addEventListener('resize', resizeListener)
    return () => {
      window.removeEventListener('resize', resizeListener)
    }
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [])

  return windowSize
}

export default useWindowResize
